
import { StoreNavItemI } from '@/stores'; // eslint-disable-line
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        routes: Array as () => StoreNavItemI[],
    }
})
